var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("search-form", {
        on: {
          search: _vm.handleFormSearch,
          export: _vm.handleFormExport,
          "export-detail": _vm.handleFormExportDetail,
          "compensation-setting": _vm.handleFormCompensationSetting,
          "id-clear": _vm.handleFormIdClear
        },
        model: {
          value: _vm.form,
          callback: function($$v) {
            _vm.form = $$v
          },
          expression: "form"
        }
      }),
      _vm._v(" "),
      _c("compensation-list", {
        attrs: {
          data: _vm.resData,
          loading: _vm.tableLoading,
          "page-size": _vm.form.pageSize,
          "current-page": _vm.form.page
        },
        on: {
          detail: _vm.handleDetail,
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "操作日志", visible: _vm.logVisible },
          on: {
            "update:visible": function($event) {
              _vm.logVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.logData } },
            [
              _c("el-table-column", {
                attrs: { property: "admin", label: "操作人", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "operate_mode",
                  label: "操作方式",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "operate_result",
                  label: "操作结果",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "created_at",
                  label: "操作时间",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "remark", label: "备注", align: "center" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "520px",
            title: "履约返佣商家名单",
            visible: _vm.supplyListVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.supplyListVisible = $event
            }
          }
        },
        [
          _c(
            "el-button",
            { attrs: { type: "success" }, on: { click: _vm.handleExport } },
            [_vm._v(" 导出名单 ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-top": "16px"
              }
            },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    action: _vm.action,
                    name: "file",
                    limit: 1,
                    "on-success": _vm.handleSupplyListUploadSuccess,
                    "on-error": _vm.handleSupplyListUploadError,
                    "show-file-list": false,
                    "auto-upload": "",
                    "with-credentials": ""
                  }
                },
                [
                  _c("el-button", { attrs: { type: "warning" } }, [
                    _vm._v(" 导入并更新名单 ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "8px" } }, [
                _vm._v(
                  "\n        导入格式：A列=商家ID，B列=履约返佣类型（代号）\n      "
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "赔付设置日志",
            visible: _vm.settingLogVisible,
            width: "82%"
          },
          on: {
            "update:visible": function($event) {
              _vm.settingLogVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.settingLogs, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "before",
                  label: "修改前",
                  "min-width": "530",
                  "header-align": "center",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.before
                          ? _c(
                              "div",
                              _vm._l(scope.row.before, function(item, index) {
                                return _c("p", { key: index }, [
                                  _vm._v(
                                    "\n              商品销售价区间：" +
                                      _vm._s(item.minPrice || "0") +
                                      "-" +
                                      _vm._s(item.maxPrice || "正无限") +
                                      "， 超时赔付计算：" +
                                      _vm._s(
                                        item.overtimeType === "percentage"
                                          ? "比例"
                                          : "绝对值"
                                      ) +
                                      _vm._s(item.overtimeValue) +
                                      _vm._s(
                                        item.overtimeType === "percentage"
                                          ? "%"
                                          : "元"
                                      ) +
                                      "，\n              断货赔付计算：" +
                                      _vm._s(
                                        item.shortageType === "percentage"
                                          ? "比例"
                                          : "绝对值"
                                      ) +
                                      _vm._s(item.shortageValue) +
                                      _vm._s(
                                        item.shortageType === "percentage"
                                          ? "%"
                                          : "元"
                                      ) +
                                      "\n            "
                                  )
                                ])
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "after",
                  label: "修改后",
                  "min-width": "530",
                  "header-align": "center",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          _vm._l(scope.row.after, function(item, index) {
                            return _c("p", { key: index }, [
                              _vm._v(
                                "\n              商品销售价区间：" +
                                  _vm._s(item.minPrice || "0") +
                                  "-" +
                                  _vm._s(item.maxPrice || "正无限") +
                                  "， 超时赔付计算：" +
                                  _vm._s(
                                    item.overtimeType === "percentage"
                                      ? "比例"
                                      : "绝对值"
                                  ) +
                                  _vm._s(item.overtimeValue) +
                                  _vm._s(
                                    item.overtimeType === "percentage"
                                      ? "%"
                                      : "元"
                                  ) +
                                  "，\n              断货赔付计算：" +
                                  _vm._s(
                                    item.shortageType === "percentage"
                                      ? "比例"
                                      : "绝对值"
                                  ) +
                                  _vm._s(item.shortageValue) +
                                  _vm._s(
                                    item.shortageType === "percentage"
                                      ? "%"
                                      : "元"
                                  ) +
                                  "\n            "
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "operator",
                  label: "操作人",
                  width: "80",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "operateTime",
                  label: "操作时间",
                  width: "180",
                  align: "center"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("compensation-setting", {
        attrs: { visible: _vm.settingDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.settingDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41082ede", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41082ede","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchantClaimsOrder/index.vue
// module id = null
// module chunks = 